import React, { useState } from 'react';
import './RequestAppoinment.css';
import { useNavigate, useLocation } from 'react-router-dom';
import backIcon from "../../Assets/Images/Expand_left.png";
import CalendarIcon from "../../Assets/Images/SVG/testlog-calendar.svg";

const RequestAppointment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { doctor } = location.state || {};

  const handleBackClick = () => {
    navigate(-1);
  };

  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);

  // Function to format date as dd/mm/yyyy
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Generate calendar dates for the current month
  const generateCalendarDates = () => {
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const calendar = [];
    let week = [];

    for (let i = 0; i < (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); i++) {
      week.push(null);
    }

    for (let day = 1; day <= daysInCurrentMonth; day++) {
      week.push({ day, isCurrentMonth: true });
      if (week.length === 7) {
        calendar.push(week);
        week = [];
      }
    }

    let nextMonthDay = 1;
    while (week.length < 7) {
      week.push({ day: nextMonthDay, isCurrentMonth: false });
      nextMonthDay++;
    }
    calendar.push(week);

    return calendar;
  };

  const handleDateClick = (day, isCurrentMonth) => {
    if (isCurrentMonth) {
      const selected = new Date(currentYear, currentMonth, day);
      setSelectedDate(selected);
    }
  };

  const handleMonthChange = (direction) => {
    if (direction === "prev") {
      setCurrentMonth((prev) => (prev === 0 ? 11 : prev - 1));
      if (currentMonth === 0) setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => (prev === 11 ? 0 : prev + 1));
      if (currentMonth === 11) setCurrentYear((prev) => prev + 1);
    }
  };

  const calendarDates = generateCalendarDates();

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot);
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const validateForm = () => {
    if (!selectedDate || !selectedSlot || !reason) {
      setError("All fields are mandatory.");
      return false;
    }
    setError("");
    return true;
  };

  const handleNextClick = () => {
    if (validateForm()) {
      setIsConfirming(true);
    }
  };

  const handleConfirm = () => {
    // Here you can handle the confirmation logic (e.g., API call)
    alert('Appointment confirmed!');
    // Reset the form
    setSelectedDate(null);
    setSelectedSlot("");
    setReason("");
    setIsConfirming(false);
  };

  const handleCancel = () => {
    setIsConfirming(false);
  };

  return (
    <div className="treminder-container-appoinment">
      <div className="sub-header">
        <button className="back-button" onClick={handleBackClick}>
          <img src={backIcon} alt="Back" className ="back-icon" />
        </button>
        <h1 className="title-mydoctors">My Doctors</h1>
      </div>

      {isConfirming ? (
        <div className="set-confirm-wrappers">
          {doctor && (
            <div className="set-confirm-doctor-section">
              <img src={doctor.image} alt={doctor.name} className="set-confirm-doctor-image" />
              <div className="set-confirm-doctor-info">
                <h3 className="set-confirm-doctor-name">{doctor.name}</h3>
                <p className="set-confirm-doctor-qualification">{doctor.qualification}</p>
              </div>
            </div>
          )}

          <div className="set-confirm-form">
            <div className="set-confirm-form-group">
              <label className="set-confirm-label" htmlFor="date-input">Date</label>
              <input type="text" id="date-input" className="set-confirm-input" value={selectedDate ? formatDate(selectedDate) : ""} readOnly />
            </div>
            <div className="set-confirm-form-group">
              <label className="set-confirm-label" htmlFor="slot-time">Slot Time</label>
              <input type="text" id="slot-time" className="set-confirm-input" value={selectedSlot || ""} readOnly />
            </div>
            <div className="set-confirm-form-group">
              <label className="set-confirm-label" htmlFor="consultation-reason">Reason for Consultation <span className="mandatory">*</span></label>
              <input type="text" id="consultation-reason" className={`set-confirm-input ${error ? "input-error" : ""}`} value={reason} onChange={handleReasonChange} />
            </div>
          </div>

          <div className="set-date-buttons">
            <button className="set-date-button set-date-back-button" onClick={handleCancel}>Back</button>
            <button className="set-date-button set-date-next-button" onClick={handleConfirm}>Confirm</button>
          </div>
          {error && <p className="error-message">{error}</p>}
        </div>
      ) : (
        <>
          <section className="appointment-section">
            {doctor ? (
              <div className="doctor-cards">
                <div className="doctor-cards-left">
                  <img src={doctor.image} alt={doctor.name} />
                </div>
                <div className="doctor-cards-right">
                  <h3>{doctor.name}</h3>
                  <p>{doctor.qualification}</p>
                </div>
              </div>
            ) : (
              <p>No doctor selected.</p>
            )}
          </section>

          <div className="set-date-header">
            Set Date{" "} <span className="mandatory">*</span>
          </div>
          <div className="set-date-calendar">
            <div className="set-date-calendar-header">
              <span className="set-date-month">
                {new Date(currentYear, currentMonth).toLocaleString("default", { month: "long" })}{" "}
                {currentYear}
              </span>
              <div className="set-date-nav-buttons">
                <button className="set-date-nav-button" onClick={() => handleMonthChange("prev")}>&lt;</button>
                <button className="set-date-nav-button" onClick={() => handleMonthChange("next")}>&gt;</button>
              </div>
            </div>
            <table className="set-date-calendar-table">
              <thead>
                <tr>
                  <th>Mo</th>
                  <th>Tu</th>
                  <th>We</th>
                  <th>Th</th>
                  <th>Fr</th>
                  <th>Sa</th>
                  <th>Su</th>
                </tr>
              </thead>
              <tbody>
                {calendarDates.map((week, index) => (
                  <tr key={index}>
                    {week.map((cell, dayIndex) => {
                      const isToday = cell && cell.isCurrentMonth && new Date(currentYear, currentMonth, cell.day).toDateString() === today.toDateString();
                      return (
                        <td
                          key={dayIndex}
                          className={`${cell ? (cell.isCurrentMonth ? "set-date-current" : "set-date-next-month") : "set-date-empty"} ${selectedDate && cell && cell.isCurrentMonth && selectedDate.toDateString() === new Date(currentYear, currentMonth, cell.day).toDateString() ? "set-date-selected" : ""} ${isToday ? "set-date-today" : ""}`}
                          onClick={() => cell && handleDateClick(cell.day, cell.isCurrentMonth)}
                        >
                          {cell ? cell.day : ""}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <h2 className="set-slot-heading">Set Slot <span className="mandatory">*</span></h2>
          <div className="set-slot-buttons-appoinments">
            {['9 AM - 12 PM', '12 PM - 3 PM', '3 PM - 6 PM', '6 PM - 9 PM'].map((slot) => (
              <button
                key={slot}
                className={`set-slot-button-appoinments ${selectedSlot === slot ? 'set-slot-selected' : ''}`}
                onClick={() => handleSlotClick(slot)}
              >
                {slot}
              </button>
            ))}
          </div>
          <div className="consultation-container">
            <label htmlFor="consultation-reason" className="consultation-label">
              Reason for Consultation <span className="mandatory">*</span>
            </label>
            <textarea
              id="consultation-reason"
              className="consultation-textarea"
              placeholder="Enter your Reason"
              value={reason}
              onChange={handleReasonChange}
            />
          </div>
          <div className="set-date-buttons">
            <button className="set-date-button set-date-back-button" onClick={handleBackClick}>Back</button>
            <button className="set-date-button set-date-next-button" onClick={handleNextClick}>Next</button>
          </div>
          {error && <p className="error-message">{error}</p>}
        </>
      )}
    </div>
  );
};

export default RequestAppointment;